import React, { Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// صفحات التطبيق
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const DashboardPage = React.lazy(() => import('./pages/DashboardPage'));
const RecipientsPage = React.lazy(() => import('./pages/RecipientsPage'));
const LocationsPage = React.lazy(() => import('./pages/LocationsPage'));
const WhatsAppBotPage = React.lazy(() => import('./pages/WhatsAppBotPage'));
const QRPage = React.lazy(() => import('./pages/QRPage'));
const ReceptionManagerLightPage = React.lazy(() => import('./pages/ReceptionManagerLightPage'));
const GroupsViewPage = React.lazy(() => import('./pages/GroupsViewPage'));

// مكون التحميل
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-4 border-green-500 border-t-transparent"></div>
  </div>
);

const App: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="/login" element={
          !user ? <LoginPage /> : <Navigate to="/" replace />
        } />
        
        {/* المسارات المحمية */}
        <Route path="/" element={
          user ? <DashboardPage /> : <Navigate to="/login" state={{ from: location }} replace />
        } />
        
        <Route path="/recipients" element={
          user ? <RecipientsPage /> : <Navigate to="/login" state={{ from: location }} replace />
        } />
        
        <Route path="/locations" element={
          user ? <LocationsPage /> : <Navigate to="/login" state={{ from: location }} replace />
        } />
        
        <Route path="/whatsapp-bot" element={
          user ? <WhatsAppBotPage /> : <Navigate to="/login" state={{ from: location }} replace />
        } />
        
        <Route path="/qr" element={
          user ? <QRPage /> : <Navigate to="/login" state={{ from: location }} replace />
        } />
        
        <Route path="/reception-manager-light" element={
          user ? <ReceptionManagerLightPage /> : <Navigate to="/login" state={{ from: location }} replace />
        } />
        
        <Route path="/groups" element={
          user ? <GroupsViewPage /> : <Navigate to="/login" state={{ from: location }} replace />
        } />

        {/* مسار غير موجود */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default App;
